export const makeMessage = (messageType, payloadType, senderId, textPayload, timelineEvents) => {
  return {
    messageType,
    payloadType,
    senderId,
    textPayload,
    timelineEvents
  }
}

/*
 * @params subject - userId
 */
export const getTimelineEvent = (type, userId, eventTimeMs = (new Date()).getTime()) => {
  return {
    eventId: guid(),
    type,
    subject: {identifier: userId},
    eventTimeMs
  }
}

export function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }

  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4();
}
